<template>

    <div>

        <loading-step v-if='initLoading' />

        <div class="d-flex justify-space-between flex-column" v-else>

            <div class="map">

                <v-card>
                    <v-card-title class="d-flex">

                        <!-- Campo de procurar endereço -->
                        <input-gmap-autocomplete />

                        <v-spacer></v-spacer>

                        <!-- Botão de mostrar criar de áreas -->
                        <div v-if="!isMobile">

                            <!-- Botão de confirmar -->
                            <transition name="router-anim">
                                <v-btn class="confirm" dark v-show="creatingPolygon || editingPolygons" :disabled='canConfirm' @click="checkEditing" absolute color="green">
                                    {{$t('confirm')}}
                                </v-btn>
                            </transition>
                            
                            <v-btn :disabled='editingPolygons' text @click="initArea">
                                <v-icon class="mr-3">{{creatingPolygon ? 'mdi-minus' : 'mdi-plus'}}</v-icon> {{creatingPolygon ?  $t('edit_areas.remove') :  $t('edit_areas.add')}}
                            </v-btn>
                            
                        </div>

                        <!-- Botão de mostrar lista de áreas -->
                        <v-btn class="mr-5" text @click="drawer = !drawer">
                            <v-icon class="mr-3">mdi-view-list</v-icon>{{$t('edit_areas.list')}}
                        </v-btn>

                    </v-card-title>
                </v-card>

                <!-- Drawer de listar áreas -->
                <v-navigation-drawer v-model="drawer" absolute temporary right>
                    <AreaList @changeAreaColor='setAreaToChangeColor($event)' :totalPages='totalPages' />
                </v-navigation-drawer>

                <!-- Mapa -->             
                <GmapMap ref="map" id="map" :center="map.center" :zoom="map.zoom" map-type-id="roadmap" @click="clickMap($event)">

                    <!-- Polígonos já criados -->
                    <gmap-polygon :key="i" v-for="(path, i) in polyToRender" :path="path" @click="clickArea({id: path[0].id, event: $event, element: 'polygon_' + path[0].id})" :options='{strokeColor: "black", fillColor: "MintCream", fillOpacity: 0.1}' :editable="editingPolygons" :ref="'polygon_' + path[0].id" />

                    <!-- Polígono sendo criado -->
                    <gmap-polygon :paths="createdPolygon" @paths_changed="updateEdited($event)" :editable="true" />

                </GmapMap>

            </div>

            <!-- Modal de tamanho de área -->
            <dialog-area-size 
                :dialogAreaSize="dialogAreaSize" 
                @closeDialog='dialogAreaSize = false' 
                @changeMultiplier='multiplierSize = $event' />

            <!-- Modal de nome de área -->
            <dialog-area-name 
                :area="area" 
                :createdPolygon="createdPolygon" 
                :dialog="dialog" 
                @closeDialog='dialog = false' 
                @cleanPolyData='cleanPolyData' 
            />

            <!-- Modal de opções de área -->
            <dialog-area-options 
                :dialogOptions='dialogOptions' 
                :clickedPolygon='clickedPolygon' 
                @closeDialog='dialogOptions = false' 
                @cleanPoly='clickedPolygon = {}' 
                @cleanPolyData='cleanPolyData' 
            />
        </div>

    </div>
</template>

<script>
import { ADD_POLY, REMOVE_LAST_POLY, GET_POLYS, SAVE_AREA, SET_POLYS, SAVE_EDITED_AREAS, SET_AREAS, SET_POLYS_BACKUP, SET_MAPPAGE, DELETE_AREA } from '../../store/mutations';
import { gmapApi } from 'vue2-google-maps';
import AreaList from '../components/dashMapArea/AreaList.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { ROUTE_PROVIDER_DASHOVER } from '../../router/routes';
import DialogAreaOptions from '../components/dashMapArea/DialogAreaOptions.vue';
import DialogAreaName from '../components/dashMapArea/DialogAreaName.vue';
import DialogAreaSize from '../components/dashMapArea/DialogAreaSize.vue';
import LoadingStep from '../components/dashMapArea/LoadingStep.vue';
import InputGmapAutocomplete from '../components/dashMapArea/InputGmapAutocomplete'

export default {
    name: 'DashMapArea',

    computed: {

        google: gmapApi,

        ...mapGetters({
            polyToRender: 'AreaVuex/polygons_render',
            page: 'AreaVuex/mapPage',
            getProvider: `ProviderVuex/provider`,
            map: 'AreaVuex/map',
            areas: 'AreaVuex/areas',

        }),

        canConfirm() {

            if (this.creatingPolygon) return this.createdPolygon.length === 0

            return false

        },

        totalPages() {

            if (!this.totalAreas) return 0

            return Math.ceil(this.totalAreas / 100)

        }

    },

    components: { AreaList, DialogAreaOptions, DialogAreaName, DialogAreaSize, LoadingStep, InputGmapAutocomplete },

    async created() {

        

        this.initLoading = true

        const areas = await this.getAreas({ page: this.page, id: this.getProvider._id })

        if (!areas) this.$router.push(ROUTE_PROVIDER_DASHOVER);

        this.totalAreas = areas.total

        this.initLoading = false

    },

    async mounted() {

        if (this.isMobile) return this.showToast(this.$t('edit_areas.instructions_msg'), this.$t('edit_areas.instructions_title_mobile'), 'info', {
            position: 'center',
            color: "#FF8C00",
            class: 'alert',
            icon: 'icon mdi mdi-map',

        })

        this.showToast(this.$t('edit_areas.instructions_msg'), this.$t('edit_areas.instructions_title'), 'info', {
            position: 'center',
            color: "#FF8C00",
            class: 'alert',
            icon: 'icon mdi mdi-arrow-top-right-thick',

        })

    },

    data() {
        return {
            initLoading: false,
            drawer: true,
            dialogOptions: false,
            editable: false,
            clickedPolygon: {},
            creatingPolygon: false, // Modo criação de polígono
            editingPolygons: false, // Modo editando polígonos
            createdPolygon: [], // Polígono sendo criado
            dialog: false,
            totalAreas: 0,
            dialogAreaSize: false,
            multiplierSize: 1,
            area: { name: '', provider: '', points: [] },
            areaRefToChangeColor: null
        };
    },

    methods: {

        ...mapActions({

            pushPolygon: `AreaVuex/${ADD_POLY}`,
            popPolygon: `AreaVuex/${REMOVE_LAST_POLY}`,
            getAreas: `AreaVuex/${GET_POLYS}`,
            saveArea: `AreaVuex/${SAVE_AREA}`,
            saveEditedAreas: `AreaVuex/${SAVE_EDITED_AREAS}`,
            deleteSelectedArea: `AreaVuex/${DELETE_AREA}`,

        }),

        ...mapMutations({ 
            setPolys: `AreaVuex/${SET_POLYS}`,  
            setPage: `AreaVuex/${SET_MAPPAGE}`, 
            setAreas: `AreaVuex/${SET_AREAS}`, 
            setPolysBackup: `AreaVuex/${SET_POLYS_BACKUP}`
        }),

        async cleanPolyData() {

            await this.setPolys([])
            await this.setAreas([])

            this.area = { name: '', provider: '', points: [] }
            this.createdPolygon = []
            this.creatingPolygon = false

            await this.getAreas({ page: this.page, id: this.getProvider._id })

        },

        clickArea(areaData) {

            this.clickedPolygon = this.areas.find(area => area._id === areaData.id)

            const refsData = areaData.element

            this.changeColor(refsData)

            this.dialogOptions = true

        },

        setAreaToChangeColor(refsData) {

            this.areaRefToChangeColor = refsData

            this.changeColor(this.areaRefToChangeColor)

        },

        async clickMap(click) {

            if (this.createdPolygon.length || !this.creatingPolygon) return

            const path = this.circleCoordinates(this.multiplierSize, 12, click.latLng.lat(), click.latLng.lng());

            return this.createdPolygon = path

        },

        circleCoordinates(radius, steps, centerX, centerY) {

            const path = []

            for (let i = 0; i < steps; i++) {

                path.push({ lng: centerY + radius * Math.sin(2 * Math.PI * (i / steps)), lat: centerX + radius * Math.cos(2 * Math.PI * (i / steps)) })
                
            }

            return path

        },

        initArea() {

            this.creatingPolygon = !this.creatingPolygon

            if (!this.creatingPolygon) return this.createdPolygon = []

            return this.dialogAreaSize = true

        },

        changeColor(refsData) {

            if (!refsData) return

            return this.$nextTick(() => {
                this.$refs[refsData][0].$polygonObject.strokeColor = 'red'
                this.$refs[refsData][0].$polygonObject.fillColor = 'red'

            });

        },

        async checkEditing() {

            if (this.creatingPolygon) return this.dialog = true

            this.updateEditedAreas()

        },

        async updateEditedAreas() {

            this.showToast(this.$t('edit_areas.toast_save_msg'), this.$t('edit_areas.toast_edit_save_title'), 'info')

            try {

                await this.saveEditedAreas(this.polyToRender)

                this.editingPolygons = false

                await this.cleanPolyData()

                await this.getAreas()

                this.showToast(this.$t('edit_areas.toast_edit_success_msg'), this.$t('edit_areas.toast_edit_success_title'), 'success')

            } catch (error) {

                this.showToast(this.$t('edit_areas.toast_error_msg'), this.$t('edit_areas.toast_error_title'), 'error')

            }

        },

        updateEdited(mvcArray) {

            let paths = [];

            for (let i = 0; i < mvcArray.getLength(); i++) {

                let path = [];

                for (let j = 0; j < mvcArray.getAt(i).getLength(); j++) {

                    let point = mvcArray.getAt(i).getAt(j);

                    path.push({ lat: point.lat(), lng: point.lng() });
                }

                paths.push(path);
            }

            if (this.creatingPolygon) return this.createdPolygon = paths[0]

            return this.setPolys(paths);

        }
    },
};
</script>

<style scoped>

    #overMap {

        pointer-events: none;
        position: absolute;
        width: 800px;
        height: 800px;
        z-index: 100;

    }

    .confirm {

        pointer-events: all;
        width: 200px;
        z-index: 999;
        margin-top: 90px;


    }

    #map {

        width: 100%;
        height: 100vh;

    }

    .index {

        z-index: 999;


    }

    .input {

        width: 40%;


    }

    .btn-next {
        color: white;
        box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.2), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 8px 10px rgba(0, 0, 0, 0.14);
    }

    .welcome-dialog {
        width: 80vw;
        background: linear-gradient(270deg, rgba(255, 255, 255, 0) 2.59%, #FFEBDD 61.46%), #FAF7F2;
        box-shadow: 0px 5px 6px rgba(0, 0, 0, 0.2), 0px 3px 16px rgba(0, 0, 0, 0.12), 0px 9px 12px rgba(0, 0, 0, 0.14);
        border-radius: 30px;
        max-width: 700px;
        min-height: 275px;
    }

    .welcome-label {
        width: content-box;
        font-size: 1.25em;
        font-weight: bold;
        padding: 1em;
        border-bottom: 2px solid orange;
    }

    /*.space-between {*/
    /*    justify-content: space-between;*/
    /*}*/

    .label-row {
        margin-bottom: 10px;
    }

    .batatinha {
        background-color: rebeccapurple;
    }

    .overflow-auto {
        overflow: auto;
    }

    .form-provider {
        width: 100%;
        padding: 20px;
        overflow: auto;
    }

    .ps {
        position: relative;
        height: 100%;
    }

    .batatinha input {
        text-align: center;
    }

    .v-btn-add {
        bottom: 0;
        position: absolute;
        margin: 0 0 0 0;
    }

    .fab-accept {
        margin: 0 0 100px 15px !important;
    }

    .map {

        height: 100vh;
        width: 100%;

    }

</style>






